import * as React from "react";

const DropDown: React.FC = () => {
    return (
        <svg 
        width="28" 
        height="28" 
        viewBox="0 0 28 28" 
        xmlns="http://www.w3.org/2000/svg">
    <path d="m7.116 10.603 4.61 4.285a.465.465 0 0 0 .312.112.446.446 0 0 0 .3-.112l4.557-4.285c.113-.12.135-.25.065-.39-.07-.142-.195-.213-.377-.213H7.415c-.173 0-.299.07-.377.212-.07.142-.044.272.078.391z" fill="#002856" fill-rule="nonzero"/>
</svg>
        
    );
};

export default React.memo(DropDown);
